module.exports = __webpack_public_path__ + "static/img/dectree_gini.81c1131.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dectree_assets/dectree_gini.png
// module id = 9IxX
// module chunks = 1